// extracted by mini-css-extract-plugin
module.exports = {"chart":"-XP7Sln","chart__caption":"_-2lAhTe","chart__total":"-pWxM1h","chart__info":"_-3vX8QD","chart__donut":"_-3snynC"};